import { render, staticRenderFns } from "./LinkageField.vue?vue&type=template&id=3973c775&scoped=true"
import script from "./LinkageField.vue?vue&type=script&lang=js"
export * from "./LinkageField.vue?vue&type=script&lang=js"
import style0 from "./LinkageField.vue?vue&type=style&index=0&id=3973c775&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3973c775",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\cxy\\project\\zcy\\zcy-dataEase\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3973c775')) {
      api.createRecord('3973c775', component.options)
    } else {
      api.reload('3973c775', component.options)
    }
    module.hot.accept("./LinkageField.vue?vue&type=template&id=3973c775&scoped=true", function () {
      api.rerender('3973c775', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/canvas/components/editor/LinkageField.vue"
export default component.exports